import React from 'react'

import { Box } from '@domain-group/suit-theme'

interface StageLayoutProps {
  children: React.ReactNode,
}

const StageLayout = (props: StageLayoutProps) => {
  const { children } = props

  return (
    <Box
      alignItems="center"
      bottom={0}
      flexDirection="column"
      flexShrink={0}
      justifyContent="flex-start"
      left={0}
      overflow="auto"
      paddingBottom="xxlarge"
      paddingLeft="xxlarge"
      paddingRight="xxlarge"
      paddingTop="xlarge"
      position="absolute"
      right={[0, 375, 375]}
      top={0}
    >
      {children}
    </Box>
  )
}

export default StageLayout
